import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'telefone'
})
export class TelefonePipe implements PipeTransform {

	transform(value: any, args?: any): any {
		let new_value = null;
		if (value) {
			new_value = "(";
			new_value += value.substr(0, 2);
			new_value += ") ";
			if(value.length == 10){
				new_value += value.substr(2, 4);
				new_value += "-";
				new_value += value.substr(6, 4);
			}else{
				new_value += value.substr(2, 5);
				new_value += "-";
				new_value += value.substr(7, 4);
			}
		}
		return new_value;
	}

}
